import { useEffect, useState } from "react";
import { GALLERY_STORAGE_KEYS } from "../gallery/keys";
import { DEFAULT_LEVEL_SETTINGS, levelBuildLabel, levelLimitFields, levelPlanLimits, levelPlanOptions, levelSettingsChanged, levelThreshold, targetLevel, } from "../gallery/levels";
import { storage } from "../storage";
// How long a finished build says so in the button's place.
const PLAN_READY_MS = 3000;
// Customize as the user last left it on this device, else everything excluded.
const loadSettings = () => {
    try {
        const saved = storage.get(GALLERY_STORAGE_KEYS.levelSettings);
        return {
            ...DEFAULT_LEVEL_SETTINGS,
            ...(saved ? JSON.parse(saved) : {}),
        };
    }
    catch {
        return DEFAULT_LEVEL_SETTINGS;
    }
};
/**
 * The Level Planner's state over `useGalleryLevelPlan`: the target level, the
 * limit fields, Customize, and a build that goes through the credit gate.
 * `coins`: the last Club Import's, the coin balance's default.
 */
export const useGalleryLevelPlanner = ({ levels, coins, creditGate, onBuilt, }) => {
    const { milestones, plan, build, building } = levels;
    const [pickedLevel, setPickedLevel] = useState();
    const level = targetLevel(milestones, plan, pickedLevel);
    const [typedLimits, setTypedLimits] = useState({});
    const limitFields = levelLimitFields(plan, coins, typedLimits);
    const [settings, setSettings] = useState(loadSettings);
    const changeSettings = (next) => {
        setSettings(next);
        storage.set(GALLERY_STORAGE_KEYS.levelSettings, JSON.stringify(next));
    };
    const [planReady, setPlanReady] = useState(false);
    useEffect(() => {
        if (!planReady)
            return;
        const timeout = setTimeout(() => setPlanReady(false), PLAN_READY_MS);
        return () => clearTimeout(timeout);
    }, [planReady]);
    const buildPlan = () => {
        if (level === undefined || !creditGate())
            return;
        void build(level, {
            ...levelPlanLimits(limitFields),
            ...levelPlanOptions(settings),
        }).then((built) => {
            setPlanReady(built);
            if (built)
                onBuilt?.();
        });
    };
    return {
        level,
        pickLevel: setPickedLevel,
        /** The picked level's score threshold. */
        targetScore: levelThreshold(milestones, level),
        /** The built plan's level's threshold, which the picked level may differ from. */
        planTarget: levelThreshold(milestones, plan?.level),
        limitFields,
        setLimit: (key, value) => setTypedLimits((prev) => ({ ...prev, [key]: value })),
        settings,
        changeSettings,
        settingsChanged: levelSettingsChanged(settings),
        /** True for a moment after a build stored a new plan. */
        planReady,
        buildPlan,
        buildLabel: levelBuildLabel({ building, level, planLevel: plan?.level }),
    };
};
//# sourceMappingURL=useGalleryLevelPlanner.js.map